import {IAirport} from "../../../store/reducers/fleetReducer/fleetReducerTypes";
import {INotificationAirport} from "../../../store/reducers/notificationsReducer/notificationsReducerTypes";

export const DisplayAirport = (airport: IAirport, type: "allInfo" | "name" | "location_and_name" | "codes" | "oneCode" = "codes") => {
  const icao = airport.icaoCode ? `${airport.icaoCode}` : "";
  const iata = airport.iataCode ? `${airport.iataCode}` : "";
  const name = airport.name ? `${airport.name}` : "";

  if (type === "location_and_name")
    return [airport.countryName, airport.name].filter(Boolean).join(', ');

  if (type === "name")
    return name;

  if (type === "codes") {
    const codes = [icao, iata].filter(Boolean).join(', ');
    return codes || name;
  }

  if (type === "oneCode") {
    return icao || iata || name;
  }

  return [icao, iata, name].filter(Boolean).join(', ');
}

export const DisplayRoute = (airports: IAirport[], type: "allInfo" | "name" | "codes" = "codes") => {
  const formattedAirports = airports.map(a => DisplayAirport(a, type));

  return formattedAirports.join(" → ");
}

export const DisplayNotificationRoute = (airports: INotificationAirport[]) => {
  const formattedAirports = airports.map(a => [a.icaoCode, a.iataCode].join(', '));

  return formattedAirports.join(" → ");
}